"use client";

import { useAuthContext } from "@/shared/auth";
import { HOME_GREETING } from "@/features/home/data/mock";

interface HomeGreetingProps {
  title?: string;
  subtitle?: string;
}

export function HomeGreeting({
  title = HOME_GREETING.title,
  subtitle = HOME_GREETING.subtitle,
}: HomeGreetingProps) {
  const { authUser } = useAuthContext();
  // Same identity as the sidebar profile label.
  const userName = authUser?.name?.trim() || "there";

  const summitLabel = "SummitAI";
  const subtitleParts = subtitle.includes(summitLabel) ? subtitle.split(summitLabel) : null;

  return (
    <div className="text-center">
      <p className="mb-2 text-[1.5rem] font-bold">
        <span className="bg-[linear-gradient(105deg,var(--breeze-blue)_0%,var(--spark-orange)_55%,var(--logo-ai-from)_100%)] bg-clip-text text-transparent">
          Hi, {userName}.
        </span>
      </p>
      <h1 className="text-[2.15rem] leading-[1.2] font-semibold text-foreground">{title}</h1>
      <p className="mt-2 text-[15px] text-muted-foreground/70">
        {subtitleParts ? (
          <>
            {subtitleParts[0]}
            <span className="font-medium text-primary">Summit</span>
            <span className="bg-[linear-gradient(135deg,var(--logo-ai-from),var(--logo-ai-to))] bg-clip-text font-semibold text-transparent">
              AI
            </span>
            {subtitleParts[1]}
          </>
        ) : (
          subtitle
        )}
      </p>
    </div>
  );
}
